
import React from 'react';

const InvoceRow = ({ invoice }) => {

  function handleOpenLink(e) {
    e.preventDefault();
    window.open(invoice.hostedInvoiceUrl, '_blank');
  }

  const toLocalString = date => {
    return new Date(date).toLocaleString();
  }

	return (
		<>
			<tr key={invoice.id} className="even:bg-gray-50 hover:bg-indigo-50">
				<td
					className="cursor-pointer w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
					{invoice.status}
				</td>

				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					<span>{invoice.billingReason}</span>
				</td>

				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					<span>{invoice.collectionMethod}</span>
				</td>
				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					<span>{toLocalString(invoice.created)}</span>
				</td>
				<td className="even:bg-white hover:even:bg-white hover:odd:bg-white odd:bg-gray-50">
					<button onClick={e => { handleOpenLink(e)}} className="ml-1 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Invoice
          </button>
				</td>
			</tr>
		</>
	);
};

export default InvoceRow;
